import { POST_URL } from '@utils/api/endpoints';
import { OrgSwitcher as SharedOrgSwitcher } from '@components/shared/org-switcher/org-switcher';
import { useResellerCustomersDropdown } from '@utils/api/resellers/use-reseller-customers-dropdown';

// Reseller-scoped switcher: lists the reseller's own sub-customers and posts
// to the reseller switch endpoint. The BE rejects anything outside the
// reseller's downline with 403, so this UI is purely an ergonomics layer.
export function ResellerOrgSwitcher() {
  return (
    <SharedOrgSwitcher
      homeOrgKeyPrefix="reseller"
      switchEndpoint={POST_URL().resellerSwitchOrganization}
      useOptions={useResellerCustomersDropdown}
      homeRedirectTo="/reseller"
      i18n={{
        confirmSubtitleKey: 'switch-org-confirm-subtitle-reseller'
      }}
    />
  );
}
